import React from "react";
import { Menu, MenuItem } from "@mui/material";

export default function SingleChoiceConditionalMenu({
  anchorEl,
  open,
  onClose,
  items = [],
  selectedValue = null,
  onSelect
}) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          mt: 0.5,
          minWidth: 160,
          borderRadius: "10px",
          boxShadow: "0px 4px 14px rgba(0,0,0,0.12)"
        }
      }}
    >
      {items.map((item) => (
        <MenuItem
          key={item.value}
          selected={item.value === selectedValue}
          onClick={() => onSelect(item.value)}
          sx={{
            fontSize: 16,
            minHeight: 44,
            px: 2,
            py: 1,
            color: "#374151"
          }}
        >
          {item.text}
        </MenuItem>
      ))}
    </Menu>
  );
}